import React from "react";
import {EventlogState} from "../EventlogState";
import * as selectors from "../selectors";
import {connect} from "react-redux";
import {
    setFromDateFilter,
    SetFromDateFilter,
    setSearchFilter,
    SetSearchFilter, setSinceLastLoginFilter, SetSinceLastLoginFilter,
    setToDateFilter,
    SetToDateFilter
} from "../actions";
import {OverlayTrigger, Popover} from "react-bootstrap";

interface ComponentState {
}

interface TagProps {
}

interface StateProps {
    sinceLastLoginFilter: boolean
}

interface DispatchProps {
    doSetSearchFilter: SetSearchFilter,
    doSetFromDateFilter: SetFromDateFilter,
    doSetToDateFilter: SetToDateFilter,
    doSetSinceLastLoginFilter: SetSinceLastLoginFilter
}

const mapStateToProps = (state: EventlogState): StateProps => {
    return {
        sinceLastLoginFilter: selectors.sinceLastLoginFilter(state)
    }
};

const mapDispatchToProps: DispatchProps = ({
    doSetSearchFilter: setSearchFilter,
    doSetFromDateFilter: setFromDateFilter,
    doSetToDateFilter: setToDateFilter,
    doSetSinceLastLoginFilter: setSinceLastLoginFilter
});

type Props = TagProps & StateProps & DispatchProps;

class EventlogFiltering extends React.Component<Props, ComponentState> {

    searchFilterChanged(event: React.ChangeEvent<HTMLInputElement>) {
        let value: string = event.target.value;
        this.props.doSetSearchFilter(value);
    }

    fromDateFilterChanged(event: React.ChangeEvent<HTMLInputElement>) {
        let value: string = event.target.value;
        let dateValue: Date = new Date(value);
        this.props.doSetFromDateFilter(dateValue);
    }

    toDateFilterChanged(event: React.ChangeEvent<HTMLInputElement>) {
        let value: string = event.target.value;
        let dateValue: Date = new Date(value);
        this.props.doSetToDateFilter(dateValue);
    }

    sinceLastLoginFilterChanged() {
        if (!this.props.sinceLastLoginFilter) {
            this.props.doSetSinceLastLoginFilter(true);
        }
        else {
            this.props.doSetSinceLastLoginFilter(false);
        }
    }

    render() {

        return (
            <div>
                <SearchFilter onSearchFilterChanged={(e: React.ChangeEvent<HTMLInputElement>) => this.searchFilterChanged(e)} />
                <DateFilter
                    onFromDateFilterChanged={(e: React.ChangeEvent<HTMLInputElement>) => this.fromDateFilterChanged(e)}
                    onToDateFilterChanged={(e: React.ChangeEvent<HTMLInputElement>) => this.toDateFilterChanged(e)}
                />
                <SinceLastLoginFilter onSinceLastLoginFilterChanged={() => this.sinceLastLoginFilterChanged()} />
            </div>
        );
    }
}

interface SearchFilterProps {
    onSearchFilterChanged: Function
}

class SearchFilter extends React.Component<SearchFilterProps, {}> {

    render() {

        return (
            <div className="search input-group pull-left">
                <input type="text" className="form-control"
                   onChange={(e) => this.props.onSearchFilterChanged(e)}
                   placeholder="Søk" aria-label="Søk"
                />
            </div>
        );
    }
}

interface DateFilterProps {
    onFromDateFilterChanged: Function,
    onToDateFilterChanged: Function
}

class DateFilter extends React.Component<DateFilterProps, {}> {

    render() {

        let dateStyle = {
            marginLeft: 10,
            width: 180
        };

        return (
            <div className="date input-group pull-left">
                <input type="date" className="form-control"
                   style={dateStyle} id="eventlogFromDate"
                   onChange={(e) => this.props.onFromDateFilterChanged(e)}
                   placeholder="Fra"
                />
                <input type="date" className="form-control"
                   style={dateStyle} id="eventlogToDate"
                   onChange={(e) => this.props.onToDateFilterChanged(e)}
                   placeholder="Til"
                />
            </div>
        );
    }
}

interface SinceLastLoginFilterProps {
    onSinceLastLoginFilterChanged: Function
}

class SinceLastLoginFilter extends React.Component<SinceLastLoginFilterProps, {}> {

    popoverHoverFocus(explanation: string) {
        return (
            <Popover id="popover-trigger-hover-focus">
                {explanation}
            </Popover>
        );
    }

    render() {

        return (
            <div className="last-login pull-left">
                <OverlayTrigger trigger={['hover', 'focus']}
                                placement="right"
                                overlay={this.popoverHoverFocus("Hva har skjedd siden sist jeg var logget inn?")}>
                    <span>
                        <i className="fas fa-user-clock"
                           onClick={() => this.props.onSinceLastLoginFilterChanged()}>
                        </i>
                    </span>
                </OverlayTrigger>
            </div>
        );
    }
}

export const ContractEventlogFiltering = connect(mapStateToProps, mapDispatchToProps)(EventlogFiltering);